import {
  AreaChartOutlined,
  BarChartOutlined,
  DotChartOutlined,
  PieChartOutlined,
  RadarChartOutlined,
  SlidersOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import IntlMessages from "utils/IntlMessages";

const { ItemGroup: MenuItemGroup, Item: MenuItem } = Menu;

const LocationAnalyticsMenuSection = ({ userLocation, isSuperAdmin }) => {
  if (isSuperAdmin) return null;

  if (userLocation === 3) {
    return (
      <MenuItemGroup
        key="lgaAnalytics"
        className="gx-menu-group"
        title={<IntlMessages id="sidebar.lgaAnalytics" />}
      >
        <MenuItem key="dashboards/lga">
          <Link to="/dashboards/lga">
            <BarChartOutlined className="icon" />
            <span>
              <IntlMessages id="sidebar.dashboard" />
            </span>
          </Link>
        </MenuItem>
        <MenuItem key="dashboards/lgaMalaria">
          <Link to="/dashboards/lgaMalaria">
            <AreaChartOutlined className="icon" />
            <span>
              <IntlMessages id="sidebar.dashboardMalaria" />
            </span>
          </Link>
        </MenuItem>
        <MenuItem key="dashboards/lgaHIV">
          <Link to="/dashboards/lgaHIV">
            <RadarChartOutlined className="icon" />
            <span>
              <IntlMessages id="sidebar.dashboardHIV" />
            </span>
          </Link>
        </MenuItem>
        <MenuItem key="dashboards/lgaTB">
          <Link to="/dashboards/lgaTB">
            <DotChartOutlined className="icon" />
            <span>
              <IntlMessages id="sidebar.dashboardTB" />
            </span>
          </Link>
        </MenuItem>
        <MenuItem key="dashboards/lgaCovid">
          <Link to="/dashboards/lgaCovid">
            <PieChartOutlined className="icon" />
            <span>
              <IntlMessages id="sidebar.dashboardCOVID" />
            </span>
          </Link>
        </MenuItem>
        <MenuItem key="dashboards/lgaLassa">
          <Link to="/dashboards/lgaLassa">
            <SlidersOutlined className="icon" />
            <span>
              <IntlMessages id="sidebar.dashboardLASSA" />
            </span>
          </Link>
        </MenuItem>
      </MenuItemGroup>
    );
  }

  if (userLocation === 2) {
    return (
      <MenuItemGroup
        key="stateAnalytics"
        className="gx-menu-group"
        title={<IntlMessages id="sidebar.stateAnalytics" />}
      >
        <MenuItem key="dashboards/state">
          <Link to="/dashboards/state">
            <BarChartOutlined className="icon" />
            <span>
              <IntlMessages id="sidebar.state_dashboard" />
            </span>
          </Link>
        </MenuItem>
        <MenuItem key="dashboards/stateMalaria">
          <Link to="/dashboards/stateMalaria">
            <AreaChartOutlined className="icon" />
            <span>
              <IntlMessages id="sidebar.dashboardMalaria" />
            </span>
          </Link>
        </MenuItem>
        <MenuItem key="dashboards/stateHIV">
          <Link to="/dashboards/stateHIV">
            <RadarChartOutlined className="icon" />
            <span>
              <IntlMessages id="sidebar.dashboardHIV" />
            </span>
          </Link>
        </MenuItem>
        <MenuItem key="dashboards/stateTB">
          <Link to="/dashboards/stateTB">
            <DotChartOutlined className="icon" />
            <span>
              <IntlMessages id="sidebar.dashboardTB" />
            </span>
          </Link>
        </MenuItem>
        <MenuItem key="dashboards/stateCovid">
          <Link to="/dashboards/stateCovid">
            <PieChartOutlined className="icon" />
            <span>
              <IntlMessages id="sidebar.dashboardCOVID" />
            </span>
          </Link>
        </MenuItem>
        <MenuItem key="dashboards/stateLassa">
          <Link to="/dashboards/stateLassa">
            <SlidersOutlined className="icon" />
            <span>
              <IntlMessages id="sidebar.dashboardLASSA" />
            </span>
          </Link>
        </MenuItem>
      </MenuItemGroup>
    );
  }

  if (userLocation === 1) {
    return (
      <MenuItemGroup
        key="federalAnalytics"
        className="gx-menu-group"
        title={<IntlMessages id="sidebar.federalAnalytics" />}
      >
        <MenuItem key="dashboards/federal">
          <Link to="/dashboards/federal">
            <BarChartOutlined className="icon" />
            <span>
              <IntlMessages id="sidebar.federal_dashboard" />
            </span>
          </Link>
        </MenuItem>
        <MenuItem key="dashboards/federalMalaria">
          <Link to="/dashboards/federalMalaria">
            <AreaChartOutlined className="icon" />
            <span>
              <IntlMessages id="sidebar.dashboardMalaria" />
            </span>
          </Link>
        </MenuItem>
        <MenuItem key="dashboards/federalHIV">
          <Link to="/dashboards/federalHIV">
            <RadarChartOutlined className="icon" />
            <span>
              <IntlMessages id="sidebar.dashboardHIV" />
            </span>
          </Link>
        </MenuItem>
        <MenuItem key="dashboards/federalTB">
          <Link to="/dashboards/federalTB">
            <DotChartOutlined className="icon" />
            <span>
              <IntlMessages id="sidebar.dashboardTB" />
            </span>
          </Link>
        </MenuItem>
        <MenuItem key="dashboards/federalCovid">
          <Link to="/dashboards/federalCovid">
            <PieChartOutlined className="icon" />
            <span>
              <IntlMessages id="sidebar.dashboardCOVID" />
            </span>
          </Link>
        </MenuItem>
        <MenuItem key="dashboards/federalLassa">
          <Link to="/dashboards/federalLassa">
            <SlidersOutlined className="icon" />
            <span>
              <IntlMessages id="sidebar.dashboardLASSA" />
            </span>
          </Link>
        </MenuItem>
      </MenuItemGroup>
    );
  }

  return null;
};

LocationAnalyticsMenuSection.propTypes = {
  userLocation: PropTypes.number,
  isSuperAdmin: PropTypes.bool,
};

export default LocationAnalyticsMenuSection;
